import MyJobModal from './MyJobModal'

var MyJobApp = new MyJobModal()
export default MyJobApp
